module.exports = __webpack_public_path__ + "assets/1a5ff7f05c16d4f4e93532da26f6fba4.jpg";